import React, { useEffect, useState } from 'react';
import { Container, Form, Header, Icon, Breadcrumb, Button, Grid, Placeholder, Segment, Message, Dropdown } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { useHistory, useLocation, useParams } from 'react-router';
import { useEditUserForm } from './useEditUserForm';
import moment from 'moment';

export function EditUserForm() {
    let { UId } = useParams<{ UId: string }>();
    let [values, masterData, errors, touched, isLoading, isSubmitting, isValid, submitSuccess, errorMessage, dataLoaded,
        registerRef, handleChange, handleBlur, handleSubmit] = useEditUserForm();
    const history = useHistory();
    //console.log(masterData);

    function handleBackToList() {
        history.push('/UsersList');
    }

    const isEdit: boolean = UId !== '0' ? true : false;
    return <Container className='providers-container'>
        <Header as='h1' style={{ marginTop: '2.0rem', marginBottom: '0.5rem' }}>{isEdit ? 'Edit' : 'Create'} User</Header>
        <hr style={{ marginBottom: '1.0rem' }} />
        <Breadcrumb style={{ marginBottom: '1.0rem' }}>
            <Breadcrumb.Section link><Link to='/dashboard'>Home</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>{isEdit ? 'Edit' : 'Create'} User</Breadcrumb.Section>
        </Breadcrumb>


        <Grid columns={2} style={submitSuccess ? { margin: 0 } : {}}>
            {
                !submitSuccess &&
                <>
                    <Grid.Column>
                        <Form loading={isSubmitting}>
                            <Form.Input className={!(!errors.firstName || !touched.firstName) ? 'mb-0' : ''}
                                required
                                fluid
                                label='First Name'
                                value={values.firstName}
                                onChange={(event, data) => {
                                    handleChange(data.value, 'firstName');
                                }}
                                onBlur={
                                    () => { handleBlur('firstName') }
                                }
                                error={!(!errors.firstName || !touched.firstName) ? true : false}
                            />
                            {
                                !(!errors.firstName || !touched.firstName) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.firstName}</div>
                            }
                            <Form.Input className={!(!errors.lastName || !touched.lastName) ? 'mb-0' : ''}
                                required
                                fluid
                                value={values.lastName}
                                label='Last Name'
                                onChange={(event, data) => {
                                    handleChange(data.value, 'lastName');
                                }}
                                onBlur={
                                    () => { handleBlur('lastName') }
                                }
                                error={!(!errors.lastName || !touched.lastName) ? true : false}
                            />
                            {
                                !(!errors.lastName || !touched.lastName) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.lastName}</div>
                            }

                            <Form.Input className={!(!errors.userName || !touched.userName) ? 'mb-0' : ''}
                                required
                                fluid
                                label='User Name'
                                value={values.userName}
                                onChange={(event, data) => {
                                    handleChange(data.value, 'userName');
                                }}
                                onBlur={
                                    () => { 
                                        //handleBlur('userName')
                                    }
                                }
                                error={!(!errors.userName || !touched.userName) ? true : false}
                            />
                            {
                                !(!errors.userName || !touched.userName) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.userName}</div>
                            }

                            <Form.Input className={!(!errors.email || !touched.email) ? 'mb-0' : ''}
                                required
                                fluid
                                label='Email Address'
                                value={values.email}
                                onChange={(event, data) => {
                                    handleChange(data.value, 'email');
                                }}
                                onBlur={
                                    () => { 
                                        //handleBlur('email')
                                     }
                                }
                                error={!(!errors.email || !touched.email) ? true : false}
                            />
                            {
                                !(!errors.email || !touched.email) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.email}</div>
                            }

                            <Form.Input className={!(!errors.password || !touched.password) ? 'mb-0' : ''}
                                fluid
                                label='Password'
                                type='password'
                                value={values.password}
                                onChange={(event, data) => {
                                    handleChange(data.value, 'password');
                                }}
                                onBlur={
                                    () => { handleBlur('password') }
                                }
                                error={!(!errors.password || !touched.password) ? true : false}
                            />
                            {
                                !(!errors.password || !touched.password) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.password}</div>
                            }
                            <Form.Field required
                                error={!(!errors.roleName || !touched.roleName) ? true : false}
                                className={!(!errors.roleName || !touched.roleName) ? 'mb-0' : ''}>
                                <label>User Role</label>
                                <Dropdown
                                    placeholder=' - Select user role - '
                                    fluid
                                    closeOnChange={true}
                                    clearable
                                    selection
                                    selectOnBlur={false}
                                    value={values.roleName}
                                    options={(masterData || []).map((item, index) => { return { value: item.name, text: item.name } })}
                                    onChange={(event, data) => {
                                        let newValue = (data as { value: any }).value;
                                        handleChange(newValue, 'roleName');
                                    }}
                                    onClose={
                                        () => { handleBlur('roleName') }
                                    }
                                    error={!(!errors.roleName || !touched.roleName) ? true : false}
                                />
                                {
                                    !(!errors.roleName || !touched.roleName) &&
                                    <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.roleName}</div>
                                }
                            </Form.Field>

                            <Button type='button' loading={isSubmitting} primary onClick={handleSubmit}>Submit</Button>
                            <Button type='button' onClick={() => { history.push('/UsersList') }}>Cancel</Button>
                        </Form>
                    </Grid.Column>
                    <Grid.Column>
                    </Grid.Column>
                </>
            }
            {
                submitSuccess &&
                <Message icon positive>
                    <Icon name='check circle outline' color='green' />
                    <Message.Content>
                        <Message.Header>Success</Message.Header>
                        <div>You have successfully {!isEdit ? 'created new user.' : 'updated user information.'}</div>
                        <div style={{ marginTop: '0.5rem' }}>
                            <Button icon labelPosition='left' size='small' onClick={handleBackToList}>
                                <Icon name='arrow circle left' />
                                <span>Back to Manage Users</span>
                            </Button></div>
                    </Message.Content>
                </Message>
            }

        </Grid>

    </Container>
}